import { useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { EVENTOS } from '@crm/shared'
import { api } from '../api/cliente'
import { pegarSocket, soltarSocket } from '../tempo-real/socket'

const CHAVE = ['conversas', 'nao-lidas-minhas'] as const
const TITULO = 'CRM FaroEscolar'

/**
 * O título da aba do navegador com as conversas não lidas da pessoa (mapa de
 * uso, 08/10/2026): "(3) CRM FaroEscolar". Com o CRM numa aba de fundo, era o
 * único jeito de ver que chegou mensagem sem trocar de aba.
 *
 * Recarrega com o toque de mensagem nova, que já vem decidido no servidor
 * para quem deve ouvir, e a cada meio minuto, para o número não envelhecer
 * quando a pessoa responde por outra aba ou alguém tira a marca.
 */
export function TituloComContador() {
  const cliente = useQueryClient()
  const { data } = useQuery({
    queryKey: CHAVE,
    queryFn: () => api<{ total: number }>('/api/chamados/nao-lidas-minhas'),
    refetchInterval: 30_000,
  })

  useEffect(() => {
    const socket = pegarSocket()
    const recarregar = () => void cliente.invalidateQueries({ queryKey: CHAVE })
    socket.on(EVENTOS.somDeMensagem, recarregar)
    return () => {
      socket.off(EVENTOS.somDeMensagem, recarregar)
      soltarSocket()
    }
  }, [cliente])

  const total = data?.total ?? 0
  useEffect(() => {
    document.title = total > 0 ? `(${total > 99 ? '99+' : total}) ${TITULO}` : TITULO
  }, [total])
  useEffect(() => () => void (document.title = TITULO), [])

  return null
}
